import { z } from 'zod'

export const COACHING_SHELL_OBSERVABILITY_CONTRACT_VERSION = '1.0.0' as const

export const coachingUserRoleSchema = z.enum([
  'super_admin',
  'admin',
  'coach',
  'company_admin',
  'cohort_lead',
  'participant',
])
export type CoachingUserRole = z.infer<typeof coachingUserRoleSchema>

export const coachingUserCreateRequestSchema = z.object({
  email: z.string().min(1),
  name: z.string().min(1),
  role: coachingUserRoleSchema,
  active: z.boolean().optional(),
}).passthrough()

export const coachingUserPatchRequestSchema = z.object({
  email: z.string().min(1).optional(),
  name: z.string().min(1).optional(),
  role: coachingUserRoleSchema.optional(),
  active: z.boolean().optional(),
}).passthrough()

export const coachingAssignableCoachSchema = z.object({
  id: z.string(),
  displayName: z.string(),
})
export const coachingAssignableCoachesResponseSchema = z.object({
  contract_version: z.string(),
  coaches: z.array(coachingAssignableCoachSchema),
})
export type CoachingAssignableCoach = z.infer<typeof coachingAssignableCoachSchema>
export type CoachingAssignableCoachesResponse = z.infer<typeof coachingAssignableCoachesResponseSchema>

export const coachingShellObservabilityResponseSchema = z.unknown()
export type CoachingShellObservabilityResponse = z.infer<typeof coachingShellObservabilityResponseSchema>
